var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoReviews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.501,
    height: 139.035,
    viewBox: "0 0 212.501 139.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856",
    transform: "translate(-5771.749 15858.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    transform: "translate(89 163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M73.227,34.58a34.091,34.091,0,0,1-3.661,15.459,34.579,34.579,0,0,1-30.918,19.12A34.091,34.091,0,0,1,23.189,65.5L0,73.227,7.73,50.039A34.091,34.091,0,0,1,4.068,34.58,34.58,34.58,0,0,1,23.189,3.661,34.091,34.091,0,0,1,38.648,0h2.034A34.5,34.5,0,0,1,73.227,32.546Z",
    transform: "translate(5782.263 -15894.55) rotate(-82)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle-2",
    "data-name": "Icon feather-message-circle",
    d: "M67.681,31.96A31.509,31.509,0,0,1,64.3,46.249,31.96,31.96,0,0,1,35.72,63.921a31.509,31.509,0,0,1-14.288-3.384L0,67.681,7.144,46.249A31.509,31.509,0,0,1,3.76,31.96,31.96,31.96,0,0,1,21.432,3.384,31.509,31.509,0,0,1,35.72,0H37.6a31.885,31.885,0,0,1,30.08,30.08Z",
    transform: "translate(5788.051 -15888.78) rotate(-87)",
    fill: "#fff",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3854",
    "data-name": "Group 3854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5185",
    "data-name": "Path 5185",
    d: "M-490.37-11600.384h13.316",
    transform: "translate(6199 -4296.614)",
    fill: "none",
    stroke: "rgba(0,0,0,0.09)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5186",
    "data-name": "Path 5186",
    d: "M-488.225-11600.384h-2.145",
    transform: "translate(6215.316 -4296.614)",
    fill: "none",
    stroke: "rgba(0,0,0,0.09)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5192",
    "data-name": "Path 5192",
    d: "M-4244.6-11230h212.5",
    transform: "translate(9927.346 -4654.358)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle-3",
    "data-name": "Icon feather-message-circle",
    d: "M93.706,44.25a43.625,43.625,0,0,1-4.685,19.782A44.25,44.25,0,0,1,49.456,88.5a43.625,43.625,0,0,1-19.782-4.685L0,93.706,9.891,64.033A43.625,43.625,0,0,1,5.206,44.25,44.25,44.25,0,0,1,29.674,4.685,43.626,43.626,0,0,1,49.456,0h2.6A44.146,44.146,0,0,1,93.706,41.647Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 5721.097, -16010.247)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle-4",
    "data-name": "Icon feather-message-circle",
    d: "M98.206,48.75a43.625,43.625,0,0,1-4.685,19.782A44.25,44.25,0,0,1,53.956,93a43.625,43.625,0,0,1-19.782-4.685L4.5,98.206l9.891-29.674A43.625,43.625,0,0,1,9.706,48.75,44.25,44.25,0,0,1,34.174,9.185,43.626,43.626,0,0,1,53.956,4.5h2.6A44.146,44.146,0,0,1,98.206,46.147Z",
    transform: "translate(5725.41 -16014.689)",
    fill: "#fff",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5187",
    "data-name": "Path 5187",
    d: "M-520.987-11762.147l8.253,7.306",
    transform: "translate(6247.69 -4253.062)",
    fill: "none",
    stroke: "rgba(0,0,0,0.09)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5188",
    "data-name": "Path 5188",
    d: "M0,0,7.2,6.137",
    transform: "translate(5741.392 -16020.414) rotate(50)",
    fill: "none",
    stroke: "rgba(0,0,0,0.09)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5189",
    "data-name": "Path 5189",
    d: "M0,0,7.2,6.138",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 5721.416, -16000.369)",
    fill: "none",
    stroke: "rgba(0,0,0,0.09)",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9469",
    "data-name": "Rectangle 9469",
    width: 31.52,
    height: 8.326,
    rx: 4.163,
    transform: "translate(5849.136 -15808.256)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9470",
    "data-name": "Rectangle 9470",
    width: 31.52,
    height: 8.326,
    rx: 4.163,
    transform: "translate(5852.109 -15805.877)",
    fill: "#ff091b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReviews);
export default __webpack_public_path__ + "static/media/no_reviews.75e3492d2a1d66b27430c2f9f2bed50f.svg";
export { ForwardRef as ReactComponent };